import { useEffect, useState } from "react";
import { type ImmutableArray, type Optional, getFirstItem, getOptionalNextItem, notOptional } from "shelving";

/** Animated series of frames. */
export function Frames({ children, loop = false }: { children: FrameElements; loop?: boolean }): React.ReactElement {
	const frames = children.filter(notOptional);
	const [frame, setFrame] = useState<FrameElement>(getFirstItem(frames));
	useEffect(() => {
		let timeout: NodeJS.Timeout;
		const showFrame = (active: FrameElement) => {
			setFrame(active);
			timeout = setTimeout(() => {
				const next = getOptionalNextItem(frames, active) || (loop ? getFirstItem(frames) : undefined);
				if (next) showFrame(next);
			}, active.props.duration);
		};
		showFrame(getFirstItem(frames));
		return () => clearTimeout(timeout);
	}, frames);
	return frame;
}

export type FrameProps = { duration: number; children: React.ReactElement };
export type FrameElement = React.FunctionComponentElement<FrameProps>;
export type FrameElements = ImmutableArray<Optional<FrameElement>>;

export function Frame({ children }: FrameProps): React.ReactElement {
	return children;
}
